__webpack_require__.p = "/imperial-assault-calculator/";